import scrollToElementTop from './scroll-to-element-top';

export default function scrollToMapTop(offsetTop = 0, immediate = false) {
	return scrollToElementTop('.ms3-map-wrapper', offsetTop, immediate);
}
